module.exports = __webpack_public_path__ + "img/1798.e8f016d7.jpg";